import { render, staticRenderFns, recyclableRender, components } from "./order.vue?vue&type=template&id=b3931cd0&scoped=true&"
var renderjs
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=b3931cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3931cd0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/my-course/order.vue"
export default component.exports